import { AnimatePresence, motion } from 'framer-motion';
import { AnimatedHeader } from '../AnimatedHeader/AnimatedHeader';
import { AdvtCenter } from '../AdvtCenter/AdvtCenter';

export const BigAdvt = ({
  title2FontSize,
  advt_info,
  currentState,
  title1FontSize,
}) => {
  return (
    <AnimatePresence mode="wait">
      {['S2'].includes(currentState) && (
        <motion.div
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          key="bigTitle">
          <AnimatedHeader key={currentState} titleFontSize={title2FontSize} />
        </motion.div>
      )}
      {['S3'].includes(currentState) && (
        <motion.div key="advt">
          <AdvtCenter advtInfo={advt_info} title1FontSize={title1FontSize} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
